// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3FRkZ","tab":"ProcedureTabs_tab__CMJf0"};